import { lazy } from 'react';
const LandingPage = lazy(() => import(/* webpackChunkName: "landing" */ '.'));
export default LandingPage;
